<template>
  <section class="content-group -bg-02 -center -no-spacer -vs-medium -column">
    <div class="group -flex -between -narrow -vs-small -vs-bottom -vs-collapse-bottom">
      <h2 class="heading -quaternary">{{ title }}</h2>
    </div>
    <div class="group -narrow -vs-small -vs-collapse-top">
      <slot />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/**
 * Simple title + slot component for showing more information on each step
 */
export default defineComponent({
  name: 'MoreInfoSection',
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },

  computed: {},

  methods: {},
})
</script>
